import { http } from './base/http';

export const VariantAPIs = {
    async createVariants(
        variants: { template_version: number; svg_file: number; name: string }[],
    ): Promise<Record<string, unknown>> {
        return await http.post('/variants', variants as unknown as Record<string, unknown>[]);
    },
};
